
import {initWebComponent} from "@/helpers/web-component-helper";
import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper";
import {getLayerByName, getLayers, updateLayer} from "@/helpers/ol/ol-layer-helper";
import {getBySelector} from "@/helpers/element-helper.js";

export class LayerInfoCharacteristicsLayerIndexComponent extends HTMLElement {
    constructor(){
        super();

        const direction = this.getAttribute('data-direction')
        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')

        const template = document.createElement('template');

        let title = ''
        switch (direction) {
            case 'first':
                title = 'Laag helemaal naar voren'
                break;
            case 'up':
                title = 'Laag naar voren'
                break;
            case 'down':
                title = 'Laag naar achteren'
                break;
            case 'latest':
                title = 'Laag helemaal naar achteren'
                break;
        }

        template.innerHTML = `<button title="${title}" class="btn btn-outline-secondary btn-sm icon-btn"><span class="fa fa-${this.getAttribute('data-icon')}"></span></button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            let lowestZindex = 0
            let highestZindex = 0
            getLayers(true).map(layer => {
                const zIndex = layer.getZIndex()

                if(zIndex < lowestZindex) {
                    lowestZindex = zIndex - 1
                }

                if(zIndex > highestZindex) {
                    highestZindex = zIndex + 1
                }
            })

            const layer = getLayerByName(bookmarkPresentationID)
            let zIndex = layer.getZIndex()

            switch (direction) {
                case 'first':
                    zIndex = highestZindex
                    break;
                case 'up':
                    zIndex++
                    zIndex = getClosestZIndex(zIndex, false)
                    break;
                case 'down':
                    zIndex = getClosestZIndex(zIndex)
                    break;
                case 'latest':
                    zIndex = lowestZindex
                    break;
            }

            updateLayer(bookmarkPresentationID, 'zIndex', zIndex)

            if(window.activeCharacteristicsBookmarkPresentations) {
                const bookmarkPresentations = window.activeCharacteristicsBookmarkPresentations
                const selectedBookmarkPresentation = bookmarkPresentations.find(bookmarkPresentation => bookmarkPresentation.BookmarkPresentationID === parseInt(bookmarkPresentationID))
                const sameNamePresentations = bookmarkPresentations.filter(bookmarkPresentation => bookmarkPresentation.DisplayName === selectedBookmarkPresentation.DisplayName && bookmarkPresentation.BookmarkPresentationID !== bookmarkPresentationID)

                sameNamePresentations.map(bookmarkPresentation => {
                    updateLayer(bookmarkPresentation.BookmarkPresentationID, 'zIndex', zIndex)
                })
            }
        })

        function getClosestZIndex(index, down = true) {

            let closestZIndex = index
            getLayers(true).map(layer => {
                const layerZIndex = layer.getZIndex()

                if(down) {
                    if(layerZIndex < index) {
                        closestZIndex = layerZIndex
                    }
                } else {
                    if(layerZIndex > index) {
                        closestZIndex = layerZIndex
                    }
                }


            })

            console.log(closestZIndex)

            return closestZIndex
        }
    }
}

